import { api } from "@/api/axios.ts";
import {
  ApiApprovalRequestApprovePayload,
  ApiApprovalRequestConfirmationCommentUpdate,
  ApiApprovalRequestFull,
  ApiApprovalRequestMyFilter,
  ApiMyWorkflowApprovalRequest,
} from "@/types/approvals/approval.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";

export const approvalRequestApi = {
  searchMy: (filter: ApiApprovalRequestMyFilter, signal?: AbortSignal) => {
    return api.post<ApiPagedData<ApiMyWorkflowApprovalRequest>>(
      "/api/v1/approval-requests/my/search",
      filter,
      signal
    );
  },
  getById: (id: number) => {
    return api.get<ApiApprovalRequestFull>(`/api/v1/approval-requests/${id}`);
  },
  approve: (id: number, payload: ApiApprovalRequestApprovePayload) => {
    return api.post<ApiOperationResult>(`/api/v1/approval-requests/${id}/approve`, payload);
  },
  reject: (id: number, payload: ApiApprovalRequestApprovePayload) => {
    return api.post<ApiOperationResult>(`/api/v1/approval-requests/${id}/reject`, payload);
  },
  cancel: (id: number) => {
    return api.post<ApiOperationResult>(`/api/v1/approval-requests/${id}/cancel`, {});
  },
  updateConfirmationComment: (id: number, payload: ApiApprovalRequestConfirmationCommentUpdate) => {
    return api.put<ApiOperationResult>(
      `/api/v1/approval-requests/${id}/confirmation/comment`,
      payload
    );
  },
};
